import styled from 'styled-components';
import theme from '../../constants/theme';

export const HilbiAlertSC = styled.div`
  position: relative;
  margin-top: 22px;
  border-radius: 16px;
  background: rgba(106, 213, 225, 0.1);
  padding: 30px 16px 16px;
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: ${theme.colors.primary};
  white-space: pre-line;

  .alert-avatar {
    position: absolute;
    top: -22px;
    left: 50%;
    margin-left: -22px;
    width: 44px;
    height: 44px;
    background: #fff;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
    border: 6px solid #fff;
    border-radius: 50%;
  }
`;
